"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REDIS_CALL = exports.GET_PRODUCT_TRANSACTIONS = exports.CONTACT_SYNC_STATUS = exports.CONTACT_SYNC = exports.CLONE_CONTENT = exports.DELETE_IMAGES = exports.QUEUE_STATUS = exports.DELETE_RECORDS = exports.DOWNLOAD_IMAGES = exports.UPLOAD_FILES = exports.DELETE_FILES = exports.ES3Folder = exports.UPLOAD_IMAGES = exports.TOGGLE_VISIBILITY = exports.UPDATE_BATCH = exports.IMPORT_BATCH = exports.VALIDATE_MOCKTEST = exports.VALIDATE_UCAT_QUESTIONS = exports.VALIDATE_QUESTIONS = exports.VALIDATE_STATIONS = exports.VALIDATE_BOOK = void 0;
const client_1 = require("@apollo/client");
exports.VALIDATE_BOOK = (0, client_1.gql) `
  mutation ValidateBook($input: ValidateBookInput!) {
    admin {
      validateBook(input: $input) {
        batchId
        logFile
        status
        message
        errors
      }
    }
  }
`;
exports.VALIDATE_STATIONS = (0, client_1.gql) `
  mutation ValidateStations($input: ValidateStationInput!) {
    admin {
      validateStations(input: $input) {
        batchId
        logFile
        status
        message
        errors
      }
    }
  }
`;
exports.VALIDATE_QUESTIONS = (0, client_1.gql) `
  mutation ValidateQuestions($input: ValidateQuestionInput!) {
    admin {
      validateQuestions(input: $input) {
        batchId
        logFile
        status
        message
        errors
      }
    }
  }
`;
exports.VALIDATE_UCAT_QUESTIONS = (0, client_1.gql) `
  mutation ValidateUcatQuestions($input: ValidateUcatQuestionInput!) {
    admin {
      validateUcatQuestions(input: $input) {
        batchId
        logFile
        status
        message
        errors
      }
    }
  }
`;
exports.VALIDATE_MOCKTEST = (0, client_1.gql) `
  mutation validateMockTest($input: ValidateMockTestInput!) {
    admin {
      validateMockTest(input: $input) {
        batchId
        logFile
        status
        message
        errors
      }
    }
  }
`;
exports.IMPORT_BATCH = (0, client_1.gql) `
  mutation ImportBatch($batchId: String!) {
    admin {
      importBatch(batchId: $batchId) {
        batchId
        logFile
        status
        message
        errors
      }
    }
  }
`;
exports.UPDATE_BATCH = (0, client_1.gql) `
  mutation UpdateBatch($batchId: String!) {
    admin {
      updateBatch(batchId: $batchId) {
        batchId
        logFile
        status
        message
        errors
      }
    }
  }
`;
exports.TOGGLE_VISIBILITY = (0, client_1.gql) `
  mutation ToggleVisibility($input: VisibilityInput!) {
    admin {
      toggleVisibility(input: $input) {
        batchId
        logFile
        status
        message
        errors
      }
    }
  }
`;
exports.UPLOAD_IMAGES = (0, client_1.gql) `
  mutation UploadImages($file: FileDataInput!) {
    admin {
      uploadImages(file: $file) {
        logFile
        status
        message
        batchId
        data
        recordIds
        errors
      }
    }
  }
`;
var ES3Folder;
(function (ES3Folder) {
    ES3Folder["Videos"] = "videos";
    ES3Folder["Files"] = "files";
    ES3Folder["Images"] = "";
    ES3Folder["AuthorImages"] = "author_images";
    ES3Folder["Blogs"] = "quesmed-bucket-images";
})(ES3Folder = exports.ES3Folder || (exports.ES3Folder = {}));
exports.DELETE_FILES = (0, client_1.gql) `
  mutation DeleteFiles($keys: [String], $parentFolder: String) {
    admin {
      deleteFiles(keys: $keys, parentFolder: $parentFolder) {
        logFile
        status
        message
        data
        errors
      }
    }
  }
`;
exports.UPLOAD_FILES = (0, client_1.gql) `
  mutation UploadFiles($file: FileDataInput!, $parentFolder: String) {
    admin {
      uploadFiles(file: $file, parentFolder: $parentFolder) {
        logFile
        status
        message
        data
        errors
      }
    }
  }
`;
exports.DOWNLOAD_IMAGES = (0, client_1.gql) `
  mutation DownloadImages($ids: [Int!]!) {
    admin {
      downloadImages(ids: $ids) {
        logFile
        status
        message
        batchId
        data
        recordIds
        errors
      }
    }
  }
`;
exports.DELETE_RECORDS = (0, client_1.gql) `
  mutation DeleteRecords($input: DeleteRecordsInput!) {
    admin {
      deleteRecords(input: $input) {
        logFile
        status
        message
        batchId
        data
        recordIds
        errors
      }
    }
  }
`;
exports.QUEUE_STATUS = (0, client_1.gql) `
  mutation QueueStatus($ids: [Int!]!) {
    admin {
      queueStatus(ids: $ids) {
        logFile
        status
        message
        data
        batchId
        recordIds
        errors
      }
    }
  }
`;
exports.DELETE_IMAGES = (0, client_1.gql) `
  mutation DeleteImages($ids: [Int!]!) {
    admin {
      deleteImages(ids: $ids) {
        logFile
        status
        batchId
        message
        data
        recordIds
        errors
      }
    }
  }
`;
exports.CLONE_CONTENT = (0, client_1.gql) `
  mutation CloneContent(
    $file: FileDataInput!
    $destination: Int!
    $source: Int!
    $type: Int!
  ) {
    admin {
      cloneContent(
        file: $file
        destination: $destination
        source: $source
        type: $type
      ) {
        status
        message
        data
        recordIds
        errors
      }
    }
  }
`;
exports.CONTACT_SYNC = (0, client_1.gql) `
  mutation ContactSync($emails: [String]) {
    admin {
      contactSync(emails: $emails) {
        status
        message
        data
        errors
      }
    }
  }
`;
exports.CONTACT_SYNC_STATUS = (0, client_1.gql) `
  mutation ContactSyncStatus($jobIds: [String]) {
    admin {
      contactSyncStatus(jobIds: $jobIds) {
        status
        message
        data
        errors
      }
    }
  }
`;
exports.GET_PRODUCT_TRANSACTIONS = (0, client_1.gql) `
  mutation GetProductTransactions($input: ProductTransactionInput!) {
    admin {
      getProductTransactions(input: $input) {
        status
        message
        data
        errors
      }
    }
  }
`;
exports.REDIS_CALL = (0, client_1.gql) `
  mutation RedisCall($input: String!) {
    admin {
      redisCall(input: $input)
    }
  }
`;
